// @ vendors
const { Promise } = require('es6-promise');
const trim = require('lodash/string/trim');
const get = require('lodash/object/get');
const moment = require('moment');
// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const { validateUIStep, validationRequest, validationSuccess, validationFailure, transferRequest, transferEditSuccess, transferFailure, isFetching, setVisibleStep } = require('actions/transferActions');
// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const transfersHelper = require('utilities/transfersHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const DateHelper = require('utilities/dateHelper');
// @ constants
const actionTypes = require('constants/actionTypes');
const {
    DEFERRED_TRANFERS,
    API_ENTERPRISE_NUMBER,
    DATE_FORMAT_API,
    EURO_TEXT,
    PERIODICITY_ANNUAL,
    PERIODICITY_CONSTANTLY,
    PERIODICITY_COUNT,
    PERIODICITY_BIANNUAL,
    PERIODICITY_DATE,
    PERIODICITY_QUARTERLY,
    PERIODICITY_MONTHLY,
    SEPA_INTERNATIONAL,
    SEPA_NATIONAL,
    TRANSFER_EMITTED_DAY_AFTER,
    TRANSFER_EMITTED_DAY_BEFORE,
    TRANSFER_MAX_IMPORT,
    TRANSFER_MIN_IMPORT,
    HYPHEN
} = require('constants/index');
// @ contact-center
const {
    CC_PERIODICITY_DAILY,
    CC_PERIODICITY_WEEKLY,
    CC_PERIODICITY_CUSTOM,
    CC_PERIODICITY_RANGE_SPECIFICATION_DAYS,
    CC_TRANSFER_TYPE_ORDINARY,
    CC_TRANSFER_TYPE_CODE_ORDINARY,
    CC_TRANSFER_TYPE_CODE_PAYROLL_NATIONAL,
    CC_TRANSFER_TYPE_CODE_PAYROLL_SEPA_INTERNATIONAL,
} = require('constants/contactCenter/transfers');

const scheduledTransfersRequest = (accountId) => ({
    type: actionTypes.FETCH_SCHEDULED_TRANSFERS_REQUEST,
    payload: {
        accountId
    }
});

const scheduledTransfersSuccess = (data, accountId) => ({
    type: actionTypes.FETCH_SCHEDULED_TRANSFERS_SUCCESS,
    payload: {
        accountId,
        nextPage: get(data, '_links.nextPage.href', ''),
        transfers: get(data, 'datosTransfPerDif.dato', [])
    }
});

const scheduledTransfersFailure = (error, accountId) => ({
    type: actionTypes.FETCH_SCHEDULED_TRANSFERS_FAILURE,
    payload: {
        accountId,
        error
    }
});

const requestNextAccountTransactionsPageSuccess = (data, accountId) => ({
    type: actionTypes.FETCH_SCHEDULED_TRANSFERS_NEXT_PAGE_SUCCESS,
    payload: {
        accountId,
        nextPage: get(data, '_links.nextPage.href', ''),
        transfers: get(data, 'datosTransfPerDif.dato', [])
    }
});

const getScheduledTransfers = (accountId, product, contractNumber, filters) => {
    return dispatch => {
        const amountCurrency = get(filters, 'amountCurrency');
        const toAmount = get(filters, 'toAmount');
        const fromAmount = get(filters, 'fromAmount');
        const requestData = {
            query: {
                producto: product,
                numeroDeContrato: contractNumber
            }
        };

        if (amountCurrency) {
            requestData.query.busquedaDivisa = amountCurrency;
        }

        if (fromAmount || toAmount) {
            requestData.query.importeDesde = fromAmount || TRANSFER_MIN_IMPORT;
            requestData.query.importeHasta = toAmount || TRANSFER_MAX_IMPORT;
            requestData.query.divisaImporteDesde = amountCurrency || EURO_TEXT;
            requestData.query.divisaImporteHasta = amountCurrency || EURO_TEXT;
        }

        dispatch(scheduledTransfersRequest(accountId));
        return APIGet(dispatch, apiURLBuilder.getURL('scheduledTransfers'), requestData).then(
            response => dispatch(scheduledTransfersSuccess(response, accountId)),
            error => dispatch(scheduledTransfersFailure(error, accountId))
        );
    }
};

const requestScheduledTransfers = (accountId) => {
    return (dispatch, getState) => {
        const immGlobalPosition = getState().globalPosition;
        if (!immGlobalPosition.get('isOutdated')) {
            // jorge.zapata If the PG has been invalidated, we don't do the request until it has been fetched again
            // This is to avoid repeated request after a transaction
            const immAccount = getState().accounts.get('byId').get(accountId);
            const immScheduledTransfersFilters = getState().scheduledTransfers.get('filters');
            let filters = {};

            // Filters left as a base for future implementation
            if (immScheduledTransfersFilters) {
                filters = {
                    fromAmount: immScheduledTransfersFilters.get('amount').get('from').get('amount'),
                    toAmount: immScheduledTransfersFilters.get('amount').get('to').get('amount'),
                    amountCurrency: immScheduledTransfersFilters.get('currency').get('value')
                }
            }

            return dispatch(getScheduledTransfers(accountId, immAccount.get('newProduct'), immAccount.get('newContractNumber'), filters));
            // getScheduledTransfers(dispatch, accountId, immAccount.get('newProduct'), immAccount.get('newContractNumber'), filters);
        } else {
            return Promise.resolve();
        }
    }
};

const requestScheduledTransfersNextPage = accountId => (dispatch, getState) => {
    const nextPageURL = getState().scheduledTransfers.getIn([accountId, 'nextPage']);

    return APIGet(dispatch, nextPageURL)
        .then(response => dispatch(requestNextAccountTransactionsPageSuccess(response, accountId)))
        .catch(error => dispatch(scheduledTransfersFailure(error.error.description, accountId)))
};

const setScheduledTransfersFilters = (filters) => ({
    type: actionTypes.SET_SCHEDULED_TRANSFERS_FILTERS, // tagged for analytics
    payload: {
        filters
    }
});

const resetScheduledTransfersFilter = (filter) => ({
    type: actionTypes.RESET_SCHEDULED_TRANSFERS_FILTER,
    payload: {
        filter
    }
});

const clearScheduledTransfersFilters = () => ({
    type: actionTypes.CLEAR_SCHEDULED_TRANSFERS_FILTERS // tagged for analytics
});

const setRemoveScheduledTransferInitial = () => ({
    type: actionTypes.SET_REMOVE_SCHEDULED_TRANSFER_INITIAL
});

const removeScheduledTransferRequest = () => ({
    type: actionTypes.REMOVE_SCHEDULED_TRANSFER_REQUEST
});

const removeScheduledTransferSuccess = () => ({
    type: actionTypes.REMOVE_SCHEDULED_TRANSFER_SUCCESS
});

const removeScheduledTransferFailure = error => ({
    type: actionTypes.REMOVE_SCHEDULED_TRANSFER_FAILURE,
    payload: {
        error
    }
});

const requestRemoveScheduledTransfer = (accountId, transferId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const immTransaction = getState().scheduledTransfers.getIn([accountId, 'byId', transferId]);

        const requestData = {
            query: {
                dataToken,
                contratoOrdenante: {
                    numerodecontrato: immAccount.get('newContractNumber'),
                    producto: immAccount.get('newProduct')
                },
                fechaProximaEjecucion: immTransaction.get('startDate').format(DATE_FORMAT_API),
                importe: {
                    divisa: immTransaction.getIn(['amount', 'currency']),
                    importe: immTransaction.getIn(['amount', 'amount'])
                },
                indicadorDifPerio: immTransaction.get('transferType') === DEFERRED_TRANFERS ? 'D' : 'P', //NOT SURE ABOUT THIS
                numeroOrdenCabecera: immTransaction.getIn(['extra', 'numOrdCabMisPag']),
                cuentaDestino: immTransaction.getIn(['details', 'beneficiaryFullIban'])
            }
        };

        dispatch(removeScheduledTransferRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('removeScheduledTransfer'), requestData)
            .then(function () {
                dispatch(removeScheduledTransferSuccess());
            }).catch(response => dispatch(removeScheduledTransferFailure(response.error.description)))
    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const setTransfer = (immscheduledTransfer, scheduledId) => {
    const endDateYear = moment(immscheduledTransfer.get('endDate')).get('year');
    const immBeneficiaryIban = immscheduledTransfer.getIn(['details', 'beneficiaryIban']);
    const transferType = immscheduledTransfer.get('transferType');
    const plainBeneficiaryIban = immBeneficiaryIban.get('pais') + immBeneficiaryIban.get('digitodecontrol') + trim(immBeneficiaryIban.get('codbban'));
    const oldEmitter = `${immscheduledTransfer.getIn(['emitter', 'type'])}${HYPHEN}${immscheduledTransfer.getIn(['emitter', 'code'])}`;

    let periodicityText = immscheduledTransfer.getIn(['details', 'periodicityText']);
    if (periodicityText === PERIODICITY_ANNUAL) {
        periodicityText = PERIODICITY_MONTHLY;
    }

    const periodicityRange = periodicityText || PERIODICITY_MONTHLY;
    const nextDate = immscheduledTransfer.getIn(['details', 'nextExecutionDate']) || moment().startOf('day');
    const periodicityMinDate = transfersHelper.getPeriodicityNextValidDate(periodicityRange, nextDate);
    let periodicityDate;

    let periodicityType;
    if (endDateYear === 9999) {
        periodicityType = PERIODICITY_CONSTANTLY;
        periodicityDate = periodicityMinDate;
    } else {
        periodicityType = PERIODICITY_DATE;
        periodicityDate = immscheduledTransfer.get('endDate');
    }

    let minDate = moment().startOf('day');
    if (transferType === DEFERRED_TRANFERS) {
        minDate = minDate.add('1', 'days'); // (juan) user cannot select today as start date for a deferred transfer
    }
    let periodicityTreatmentNonWorkableDay = immscheduledTransfer.getIn(['details', 'treatmentNonWorkableDay']);

    if (![TRANSFER_EMITTED_DAY_AFTER, TRANSFER_EMITTED_DAY_BEFORE].includes(periodicityTreatmentNonWorkableDay)) {
        periodicityTreatmentNonWorkableDay = TRANSFER_EMITTED_DAY_BEFORE;
    }
    
    return {
        type: actionTypes.TRANSFER_FILL_FORM,
        payload: {
            scheduledId,
            minDate,
            plainBeneficiaryIban,
            periodicityType,
            periodicityRange,
            periodicityMinDate,
            periodicityDate,
            periodicityTreatmentNonWorkableDay,
            oldEmitter,
            amount: immscheduledTransfer.getIn(['amount', 'amount']),
            currency: immscheduledTransfer.getIn(['amount', 'currency']),
            concept: immscheduledTransfer.get('concept'),
            date: transferType === DEFERRED_TRANFERS ? immscheduledTransfer.get('startDate') : nextDate,
            beneficiaryName: immscheduledTransfer.getIn(['details', 'name']),
            beneficiaryCountry: immscheduledTransfer.getIn(['details', 'beneficiaryCountry']),
            periodicityEnabled: transferType !== DEFERRED_TRANFERS,
            periodicityRangeQuantity: immscheduledTransfer.getIn(['details', 'periodicityRangeQuantity']),
            periodicityRangeSpecified: immscheduledTransfer.getIn(['details', 'periodicityRangeSpecified']),
        }
    };
};

const fillTransferForm = (accountId, scheduledId) => (dispatch, getState) => {
    const immscheduledTransfer = getState().scheduledTransfers.getIn([accountId, 'byId', scheduledId]);
    
    if (immscheduledTransfer && immscheduledTransfer.get('details')) {
        return dispatch(setTransfer(immscheduledTransfer, scheduledId));
    }
};

const setRequestData = (immTransfer, immBeneficiary, requestData) => {
    const isSepa = transfersHelper.isSepa(immBeneficiary.get('country'), immBeneficiary.get('currency'));

    if (isSepa) {
        requestData.query.cuentaIbanBeneficiario = immBeneficiary.get('iban').toUpperCase();
    } else {
        requestData.query.cuentaIbanBeneficiario = immBeneficiary.get('accountNumber');
    }

    if (immTransfer.get('periodicityEnabled')) {
        let rangeCode;

        requestData.query.tipoTransferencia = 'PERIODICA';

        switch (immTransfer.get('periodicityRange')) {
            case CC_PERIODICITY_DAILY:
                rangeCode = '101';
                requestData.query.periodicidades = {
                    "periodicidad": [
                        {
                            "dia": 1,
                            "mes": 0,
                            "tiempo": 1
                        }
                    ]
                };
                break;
            case CC_PERIODICITY_WEEKLY:
                rangeCode = '107';
                requestData.query.fechaInicioVigencia = transfersHelper.getInitialWeekDayDate(immTransfer.get('date'), immTransfer.get('selectedWeekDay')).format(DATE_FORMAT_API);
                requestData.query.fechaProximaEjecucion = requestData.query.fechaInicioVigencia;
                requestData.query.periodicidades = {
                    "periodicidad": [
                        {
                            "dia": immTransfer.get('selectedWeekDay'),
                            "mes": 0,
                            "tiempo": 1
                        }
                    ]
                };
                break;
            case PERIODICITY_MONTHLY:
                rangeCode = '201';
                if (__CONTACT_CENTER__) {
                    requestData.query.periodicidades = {
                        "periodicidad": [
                            {
                                "dia": immTransfer.get('date').date(),
                                "mes": 0,
                                "tiempo": 1
                            }
                        ]
                    };
                }
                break;
            case PERIODICITY_QUARTERLY:
                rangeCode = '203';
                if (__CONTACT_CENTER__) {
                    requestData.query.periodicidades = {
                        "periodicidad": [
                            {
                                "dia": immTransfer.get('date').date(),
                                "mes": 0,
                                "tiempo": 3
                            }
                        ]
                    };
                }
                break;
            case PERIODICITY_BIANNUAL:
                rangeCode = '206';
                if (__CONTACT_CENTER__) {
                    requestData.query.periodicidades = {
                        "periodicidad": [
                            {
                                "dia": immTransfer.get('date').date(),
                                "mes": 0,
                                "tiempo": 6
                            }
                        ]
                    };
                }
                break;

                case CC_PERIODICITY_CUSTOM:
                    if (immTransfer.get('periodicityRangeSpecified') === CC_PERIODICITY_RANGE_SPECIFICATION_DAYS) {
                        rangeCode = '200'; // Multiple days, always monthly
                        requestData.query.periodicidades = {
                            "periodicidad": transfersHelper.getCustomPeriodicityArrayFromSelectedMonthDays(immTransfer)
                        };
                    } else {
                        rangeCode = transfersHelper.getPeriodicityCodeFromMonths(parseInt(immTransfer.get('periodicityRangeQuantity'), 10));
                        requestData.query.periodicidades = {
                            "periodicidad": transfersHelper.getCustomPeriodicityArrayFromDate(immTransfer)
                        };
                    }
                    break;
        }

        requestData.query.indicadorPeriodicidad = {
            codigoalfanum3: rangeCode
        };

        requestData.query.periodicidades = {
            periodicidad: [{
                dia: immTransfer.get('date').date(), //get number of day from date
                mes: 0,
                tiempo: 1
            }]
        };

        switch (immTransfer.get('periodicityType')) {
            case PERIODICITY_CONSTANTLY:
                requestData.query.fechaFinVigencia = '9999-01-01'; // @ this is not hardcoded, use a long date on purpose for type constantly
                break;
            case PERIODICITY_DATE:
                requestData.query.fechaFinVigencia = immTransfer.get('periodicityDate').format(DATE_FORMAT_API);
                break;
            case PERIODICITY_COUNT:
                requestData.query.fechaFinVigencia = immTransfer.get('periodicityEstimatedEndDate').format(DATE_FORMAT_API);
                break;
        }
    } else {
        if (immTransfer.get('isToday')) {
            requestData.query.tipoTransferencia = 'EMISION';
        } else {
            requestData.query.tipoTransferencia = 'DIFERIDA';
        }
    }

    if (__CONTACT_CENTER__) {
        const sepaType = transfersHelper.getSepaTypeTransfers(
            immBeneficiary.get('country'),
            immBeneficiary.get('currency'),
            immBeneficiary.get('iban')
        );

        if (sepaType === SEPA_NATIONAL) {
            requestData.query.tipoOperacion.indtipoperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_NATIONAL;
        } else if (sepaType === SEPA_INTERNATIONAL) {
            requestData.query.tipoOperacion.indtipoperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_SEPA_INTERNATIONAL;
        }
    }
};

const validateWithAPI = () => (dispatch, getState) => {
    const immTransfer = getState().transfer.getIn(['steps', 0]);
    const valid = immTransfer.get('valid');

    if (valid) {
        const accountId = immTransfer.get('fromAccount');
        const transferId = immTransfer.get('scheduledId');
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const immTransaction = getState().scheduledTransfers.getIn([accountId, 'byId', transferId]);
        const immBeneficiary = immTransfer.getIn(['beneficiary', 'new']);

        let requestData = {
            header: {
                version: "2"
            },
            query: {
                contratoOrdenante: {
                    numerodecontrato: immAccount.get('newContractNumber'),
                    producto: immAccount.get('newProduct')
                },
                importe: {
                    importe: immTransfer.get('amount'),
                    divisa: immBeneficiary.get('currency')
                },
                concepto: immTransfer.get('concept'),
                divisaOrd: immAccount.getIn(['balance', 'currency']),
                indicadorResidenciaDestinatario: immTransfer.get('isResident'),
                beneficiario: {
                    numerodeactuante: immTransaction.getIn(['details', 'beneficiary', 'numerodeactuante']),
                    tipodeactuante: {
                        codtipodeactuante: immTransaction.getIn(['details', 'beneficiary', 'tipodeactuante', 'codtipodeactuante']),
                        empresa: API_ENTERPRISE_NUMBER
                    }
                },
                indicadorTratamientoFechaEmis: immTransfer.get('periodicityTreatmentNonWorkableDay'),
                fechaInicioVigencia: immTransfer.get('date').format(DATE_FORMAT_API),
                fechaProximaEjecucion: immTransfer.get('date').format(DATE_FORMAT_API),
                tipoOperacion: {
                    indtipoperacion: immTransaction.getIn(['details', 'operationType', 'indtipoperacion']),
                    naturalezapagomispag: {
                        codalfanum: immTransaction.getIn(['details', 'operationType', 'naturalezapagomispag', 'codalfanum'])
                    }
                }
            }
        };

        setRequestData(immTransfer, immBeneficiary, requestData);

        dispatch(validationRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('scheduledTransferEditValidation'), requestData)
            .then((response) => {
                dispatch(isFetching(false));
                dispatch(setVisibleStep(2))
                return dispatch(validationSuccess(response));
            })
            .catch((response) => {
                scrollToTop();
                return dispatch(validationFailure(response.error));
            })
    }

    scrollToTop();
    return Promise.resolve();
};

const validateEditedScheduledTransfer = step => dispatch => {
    dispatch(validateUIStep(step));
    dispatch(validateWithAPI());
};

const postEditedScheduledTransfer = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immTransfer = getState().transfer.getIn(['steps', 0]);
        const accountId = immTransfer.get('fromAccount');
        const transferId = immTransfer.get('scheduledId');
        const immTransaction = getState().scheduledTransfers.getIn([accountId, 'byId', transferId]);

        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const immBeneficiary = immTransfer.getIn(['beneficiary', 'new']);
        const date = immTransfer.get('date');
        const formattedDate = date.format(DATE_FORMAT_API);
        let requestData = {
            header: {
                version: "2"
            },
            query: {
                dataToken: dataToken,
                contratoOrdenante: {
                    numeroContrato: immAccount.get('newContractNumber'),
                    producto: immAccount.get('newProduct')
                },
                codibanOrdenante: immAccount.get('iban'),
                importe: {
                    importe: immTransfer.get('amount'),
                    divisa: immBeneficiary.get('currency')
                },
                // @hardcoded - Until we know where 'importeDiferencia' comes
                importeDiferencia: {
                    importe: immTransfer.get('amount'),
                    divisa: immBeneficiary.get('currency')
                },
                concepto: immTransfer.get('concept'),
                nombreCompletoBeneficiario: immBeneficiary.get('name'),
                paisDestino: immBeneficiary.get('country'),
                indicadorResidenciaDestinatario: immTransfer.get('isResident'),
                fechaInicioVigencia: formattedDate,
                fechaProximaEjecucion: formattedDate,
                indicadorTratamientoFechaEmis: immTransfer.get('periodicityTreatmentNonWorkableDay'),
                tipoOperacion: {
                    indtipoperacion: immTransaction.getIn(['details', 'operationType', 'indtipoperacion']),
                    naturalezapagomispag: {
                        codalfanum: immTransaction.getIn(['details', 'operationType', 'naturalezapagomispag', 'codalfanum'])
                    }
                },
                numeroOrdenCabecera: immTransaction.getIn(['extra', 'numOrdCabMisPag']),
                dia: DateHelper.getDay(date),
                mes: DateHelper.getMonth(date)
            }
        };

        if (!!immTransfer.get('emitter')) {
            const emitterValues = immTransfer.get('emitter').split(HYPHEN);
            requestData.query.personaTitular = {
                codigodepersona: parseInt(emitterValues[1]),
                tipodepersona: emitterValues[0]
            };
        }

        setRequestData(immTransfer, immBeneficiary, requestData);

        dispatch(transferRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('scheduledTransferEditConfirmation'), requestData)
            .then(response => { dispatch(transferEditSuccess(response)) })
            .catch(response => { dispatch(transferFailure(response.error)) })
    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
};

module.exports = {
    clearScheduledTransfersFilters,
    fillTransferForm,
    postEditedScheduledTransfer,
    requestRemoveScheduledTransfer,
    requestScheduledTransfers,
    resetScheduledTransfersFilter,
    requestScheduledTransfersNextPage,
    setScheduledTransfersFilters,
    setRemoveScheduledTransferInitial,
    validateEditedScheduledTransfer
};
